import Flickity from 'flickity';

let activeCarousel = null;
let activeIndex = 0;

const swappers = document.querySelector('.js-category-carousel-swappers');
const carousels = Array.from(document.querySelectorAll('.js-category-carousel'));

if (swappers && carousels.length) {
    const initCarousel = () => {
        const isMobile = window.matchMedia(`(max-width: 640px)`).matches;
        carousels[activeIndex].classList.remove('hidden');

        activeCarousel = new Flickity(carousels[activeIndex], {
            cellAlign: isMobile ? 'center' : 'left',
            prevNextButtons: false,
            pageDots: true,
            groupCells: true
        });

        window.setTimeout(() => activeCarousel.resize(), 300);
    };

    const reset = () => {
        activeCarousel.destroy();
        carousels.forEach((carousel) => carousel.classList.add('hidden'));
        initCarousel();
    };

    swappers.addEventListener('swap-carousel', (e) => {
        activeIndex = e.detail.active;
        reset();
    });

    window.addEventListener('resize', reset);

    initCarousel(0);
}
